import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJabberComponent } from './simple-icons-jabber.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJabberComponent ],
    exports:      [ SimpleIconsJabberComponent ],
    bootstrap:    []
})
export class SimpleIconsJabberModule {}
